import React, {useEffect, useState} from 'react'
import {inject, observer} from 'mobx-react'

export default inject("rootstore", "langstore")(observer((props) => {
    const [localNotifications, setLocalNotifications] = useState([]);

    useEffect(() => {
        setLocalNotifications([...props.rootstore.notifications]);
    }, []);

    return (
        <div className="ts_view_content">
            <div className="row">
                <div className="col-12">
                    <h1 className={'mb-3'}>{props.langstore.t("ui_errortitle", "C'è stato un problema")}</h1>
                    <h4 className={'mb-5'}>{props.langstore.t("ui_errorsubtitle", "Qualcosa non ha funzionato.")}</h4>
                    <div onClick={() => props.rootstore.routeChange('/')} className="ts_button1">
                        <i className="fas fa-home"/>
                        {props.langstore.t('','Home')}
                    </div>
                    {(!props.rootstore.config.development.production && localNotifications.length > 0) &&
                        <div className={'mt-5'}>
                            <h5 className={'mb-3'}>Debug notification messages:</h5>
                            <pre style={{ background: '#f5f5f5', padding: '10px' }}>
                                {JSON.stringify(localNotifications, null, 2)}
                            </pre>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}));
